module.exports = __webpack_public_path__ + "static/img/1.cd98364.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/1.png
// module id = ViHq
// module chunks = 0